<script setup lang="ts">
const props = defineProps<{
  title: string;
  description: string;
  rating_title?: string;
  rating?: number;
  image?: {
    documentId: string,
    height: number,
    id: number,
    mime: string,
    size: number,
    url: string,
    width: number,
  },
  image_mob?: {
    documentId: string,
    height: number,
    id: number,
    mime: string,
    size: number,
    url: string,
    width: number,
  },
  rating_logo?: {
    documentId: string,
    height: number,
    id: number,
    mime: string,
    size: number,
    url: string,
    width: number,
  },
  rating_stars?: {
    documentId: string,
    height: number,
    id: number,
    mime: string,
    size: number,
    url: string,
    width: number,
  },
}>();

</script>
<template>
  <section class="appblock section-offset" dir="auto">
    <div class="container">
      <div class="appblock__wrapper">
        <div class="appblock__content">
          <h3>{{ props.title }}</h3>
          <p>{{ props.description }}</p>
          <div class="rating">
            <img
              v-if="props.rating_logo" class="rating__picture rating__picture--logo" :src="props.rating_logo.url"
              alt=""
            >
            <img
              v-if="props.rating_stars" class="rating__picture rating__picture--stars" :src="props.rating_stars.url"
              alt=""
            >
            <span v-if="props.rating_title" class="rating__reviews">{{ props.rating_title }}</span>
          </div>
        </div>
        <div class="appblock__images">
          <img v-if="props.image" :src="props.image.url" class="appblock__images-picture" alt="">
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import "./AppBlock";
</style>
